import { IBaseComponent } from "../models/formFields.interfaces";
import { AbstractFormComponent } from "./AbstractFormComponent";

// TODO(i18n): This component inherits error rendering from AbstractFormComponent.
// Error messages, help text, warning titles/text, and tooltip text passed as props
// should be translated by the caller before being passed to this component.
// Verify all usage sites translate these strings appropriately.
// TODO(ssr, LEVEL 1 out of 10): Migrate to functional component
// Complexity: Trivial - empty class that purely inherits behavior from AbstractFormComponent. No
// custom methods, state, or logic. Exists only to provide a named component for non-field errors.
// Migration: After AbstractFormComponent is migrated, this becomes a simple alias/wrapper. Replace
// with: export const NonFieldErrors = (props: IBaseComponent) => <FormFieldWrapper {...props} />;
// This is the simplest migration in the entire form component hierarchy.
export class NonFieldErrors extends AbstractFormComponent<
    IBaseComponent,
    Record<string, never>
> {}
